import { render } from "./PaginationController.vue?vue&type=template&id=19f95a05&scoped=true"
import script from "./PaginationController.vue?vue&type=script&lang=js"
export * from "./PaginationController.vue?vue&type=script&lang=js"

import "./PaginationController.vue?vue&type=style&index=0&id=19f95a05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f95a05"]])

export default __exports__